import React from 'react';
import { PRODUCT_TYPE_IDS, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants'
import * as CONSTANTS from "common/utils/data_validations"
import { LEAD_INTEGRATION_PHASE, TOOLTIP_CONSTANTS, optionsApiResponseTypes, optionsBidTypes, optionsLeadIntegrationPhase } from 'pages/integrations/integration-components/connector/Connector';
import { bsh_isAdminUserDetailsPresent } from 'helpers/sf_browser_storage_helper';
import { Col, Input, Row } from 'reactstrap';
import LabelWithTooltip from 'components/Common/LabelWithTooltip';
import Select from 'react-select';
import useFeatureFlagsForAccounts from 'hooks/useFeatureFlagsForAccounts';
import { useSelector } from 'react-redux';
import { isInsuranceioBrand } from 'config';

// Add static bids tooltip constant
const STATIC_BIDS_TOOLTIP = {
    ID: "ping_integration_tooltip_static_bids",
    NAME: "Static Bids",
    TOOLTIP_MESSAGE: "Enable this if your integration uses fixed/static bid amounts instead of dynamic bidding"
};

const PingIntegration = ({ validation, integration_type }) => {
    const [isFeatureFlagActiveForAccounts] = useFeatureFlagsForAccounts();

    const { current_account } = useSelector((state) => ({
        current_account: state.accounts.current_account,
    }));

    const isStaticBidsFeatureEnabled = isFeatureFlagActiveForAccounts(
        REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_STATIC_BIDS_INTEGRATION,
        current_account
    );

    return (
        <Row>
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.PHASE.NAME} tooltip_message={TOOLTIP_CONSTANTS.PHASE.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.PHASE.ID} htmlFor="response-type" />
                    <Select
                        options={optionsLeadIntegrationPhase}
                        classNamePrefix="select2-selection"
                        onChange={option => {
                            let event = {
                                target: {
                                    name: "lead_integration_phase",
                                    value: option,
                                },
                            }
                            validation.handleChange(event)
                        }}
                        onBlur={() => {
                            validation.handleBlur({
                                target: { name: "lead_integration_phase" },
                            })
                        }}
                        value={validation.values.lead_integration_phase}
                        invalid={
                            validation.touched.lead_integration_phase &&
                                validation.errors.lead_integration_phase
                                ? true
                                : false
                        }
                    />
                    {validation.touched.lead_integration_phase &&
                        validation.errors.lead_integration_phase ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.API_RESPONSE_TYPE.NAME} tooltip_message={TOOLTIP_CONSTANTS.API_RESPONSE_TYPE.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.API_RESPONSE_TYPE.ID} htmlFor="response-type" />
                    <Select
                        options={optionsApiResponseTypes}
                        classNamePrefix="select2-selection"
                        onChange={option => {
                            let event = {
                                target: {
                                    name: "api_response_type",
                                    value: option,
                                },
                            }
                            validation.handleChange(event)
                        }}
                        onBlur={() => {
                            validation.handleBlur({
                                target: { name: "api_response_type" },
                            })
                        }}
                        value={validation.values.api_response_type}
                        invalid={
                            validation.touched.api_response_type &&
                                validation.errors.api_response_type
                                ? true
                                : false
                        }
                    />
                    {validation.touched.api_response_type &&
                        validation.errors.api_response_type ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            {(integration_type?.value === PRODUCT_TYPE_IDS.LEADS || (!integration_type?.value)) && (
                <>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.BID_TYPES.NAME} tooltip_message={TOOLTIP_CONSTANTS.BID_TYPES.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BID_TYPES.ID} htmlFor="connectio-type" />
                            <Select
                                options={optionsBidTypes}
                                classNamePrefix="select2-selection"
                                onChange={option => {
                                    let event = {
                                        target: {
                                            name: "bid_types",
                                            value: option,
                                        },
                                    }
                                    validation.handleChange(event)
                                }}
                                onBlur={() => {
                                    validation.handleBlur({
                                        target: { name: "bid_types" },
                                    })
                                }}
                                value={validation.values.bid_types}
                                invalid={
                                    validation.touched.bid_types &&
                                        validation.errors.bid_types
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.bid_types &&
                                validation.errors.bid_types ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.LEG_TYPE.NAME} tooltip_message={TOOLTIP_CONSTANTS.LEG_TYPE.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.LEG_TYPE.ID} htmlFor="connectio-type" />
                            <Input
                                className="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="leg_type"
                                value={validation.values.leg_type}
                                invalid={
                                    validation.touched.leg_type &&
                                        validation.errors.leg_type
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.leg_type &&
                                validation.errors.leg_type ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                </>)}
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.PING_ID.NAME} tooltip_message={TOOLTIP_CONSTANTS.PING_ID.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.PING_ID.ID} htmlFor="connectio-type" />
                    <Input
                        className="form-control"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        name="ping_id"
                        value={validation.values.ping_id}
                        invalid={
                            validation.touched.ping_id &&
                                validation.errors.ping_id
                                ? true
                                : false
                        }
                    />
                    {validation.touched.ping_id &&
                        validation.errors.ping_id ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.BID.NAME} tooltip_message={TOOLTIP_CONSTANTS.BID.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BID.ID} htmlFor="connectio-type" />
                    <Input
                        className="form-control"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        name="bid"
                        value={validation.values.bid}
                        invalid={
                            validation.touched.bid &&
                                validation.errors.bid
                                ? true
                                : false
                        }
                    />
                    {validation.touched.bid &&
                        validation.errors.bid ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            {validation.values.lead_integration_phase?.value === LEAD_INTEGRATION_PHASE.PING &&
                bsh_isAdminUserDetailsPresent() && (
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.MIN_BID.NAME} tooltip_message={TOOLTIP_CONSTANTS.MIN_BID.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.MIN_BID.ID} htmlFor="min-bid" isAdminSettingIcon={true} />
                            <Input
                                className="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="min_bid"
                                value={validation.values.min_bid}
                            />
                        </div>
                    </Col>
                )}
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.BUYER_NAME.NAME} tooltip_message={TOOLTIP_CONSTANTS.BUYER_NAME.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BUYER_NAME.ID} htmlFor="connectio-type" />
                    <Input
                        className="form-control"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        name="buyer_name"
                        value={validation.values.buyer_name}
                        invalid={
                            validation.touched.buyer_name &&
                                validation.errors.buyer_name
                                ? true
                                : false
                        }
                    />
                    {validation.touched.buyer_name &&
                        validation.errors.buyer_name ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.BUYERS.NAME} tooltip_message={TOOLTIP_CONSTANTS.BUYERS.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BUYERS.ID} htmlFor="connectio-type" />
                    <Input
                        className="form-control"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        name="buyers"
                        value={validation.values.buyers}
                        invalid={
                            validation.touched.buyers &&
                                validation.errors.buyers
                                ? true
                                : false
                        }
                    />
                    {validation.touched.buyers &&
                        validation.errors.buyers ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            <Col md={6} xl={6}>
                <div className="mb-3">
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.BID_ID.NAME} tooltip_message={TOOLTIP_CONSTANTS.BID_ID.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BID_ID.ID} htmlFor="connectio-type" />
                    <Input
                        className="form-control"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        name="bid_id"
                        value={validation.values.bid_id}
                        invalid={
                            validation.touched.bid_id &&
                                validation.errors.bid_id
                                ? true
                                : false
                        }
                    />
                    {validation.touched.bid_id &&
                        validation.errors.bid_id ? (
                        <span className="text-danger">
                            {CONSTANTS.STR_REQUIRED_FIELD}
                        </span>
                    ) : null}
                </div>
            </Col>
            {(integration_type?.value === PRODUCT_TYPE_IDS.CALLS || (!integration_type?.value)) && (
                <>
                    {bsh_isAdminUserDetailsPresent() && (
                        <Col md={6} xl={6}>
                            <div className="mb-3">
                                <LabelWithTooltip name={TOOLTIP_CONSTANTS.BILLABLE_DURATION.NAME} tooltip_message={TOOLTIP_CONSTANTS.BILLABLE_DURATION.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.BILLABLE_DURATION.ID} htmlFor="response-type" isAdminSettingIcon={true} />
                                <Input
                                    classNamePrefix="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    name="billable_duration"
                                    value={validation.values.billable_duration}
                                    invalid={
                                        validation.touched.billable_duration &&
                                            validation.errors.billable_duration
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.billable_duration &&
                                    validation.errors.billable_duration ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </div>
                        </Col>
                    )}
                    {/* Transfer Number */}
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.TRANSFER_NUMBER.NAME} tooltip_message={TOOLTIP_CONSTANTS.TRANSFER_NUMBER.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.TRANSFER_NUMBER.ID} htmlFor="response-type" />
                            <Input
                                type="text"
                                name="transfer_number"
                                value={validation.values.transfer_number || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={!!(validation.touched.transfer_number && validation.errors.transfer_number)}
                                className="form-control"
                                autoComplete="off"
                            />
                        </div>
                    </Col>
                    {/* Transfer Number ends */}
                </>)}
            {(integration_type?.value === PRODUCT_TYPE_IDS.CLICKS || (!integration_type?.value)) && (
                <>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.CLICK_URL.NAME} tooltip_message={TOOLTIP_CONSTANTS.CLICK_URL.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.CLICK_URL.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="click_url"
                                value={validation.values.click_url}
                                invalid={
                                    validation.touched.click_url &&
                                        validation.errors.click_url
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.click_url &&
                                validation.errors.click_url ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.TITLE.NAME} tooltip_message={TOOLTIP_CONSTANTS.TITLE.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.TITLE.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="title"
                                value={validation.values.title}
                                invalid={
                                    validation.touched.title &&
                                        validation.errors.title
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.title &&
                                validation.errors.title ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.DESCRIPTION.NAME} tooltip_message={TOOLTIP_CONSTANTS.DESCRIPTION.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.DESCRIPTION.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="description"
                                value={validation.values.description}
                                invalid={
                                    validation.touched.description &&
                                        validation.errors.description
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.description &&
                                validation.errors.description ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.LOGO_URL.NAME} tooltip_message={TOOLTIP_CONSTANTS.LOGO_URL.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.LOGO_URL.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="logo_url"
                                value={validation.values.logo_url}
                                invalid={
                                    validation.touched.logo_url &&
                                        validation.errors.logo_url
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.logo_url &&
                                validation.errors.logo_url ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.SITE_HOST.NAME} tooltip_message={TOOLTIP_CONSTANTS.SITE_HOST.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.SITE_HOST.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="site_host"
                                value={validation.values.site_host}
                                invalid={
                                    validation.touched.site_host &&
                                        validation.errors.site_host
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.site_host &&
                                validation.errors.site_host ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.COMPANY_NAME.NAME} tooltip_message={TOOLTIP_CONSTANTS.COMPANY_NAME.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.COMPANY_NAME.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="company_name"
                                value={validation.values.company_name}
                                invalid={
                                    validation.touched.company_name &&
                                        validation.errors.company_name
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.company_name &&
                                validation.errors.company_name ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.DISPLAY_NAME.NAME} tooltip_message={TOOLTIP_CONSTANTS.DISPLAY_NAME.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.DISPLAY_NAME.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="display_name"
                                value={validation.values.display_name}
                                invalid={
                                    validation.touched.display_name &&
                                        validation.errors.display_name
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.display_name &&
                                validation.errors.display_name ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.IMPRESSION_PIXEL.NAME} tooltip_message={TOOLTIP_CONSTANTS.IMPRESSION_PIXEL.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.IMPRESSION_PIXEL.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="impression_pixel"
                                value={validation.values.impression_pixel}
                                invalid={
                                    validation.touched.impression_pixel &&
                                        validation.errors.impression_pixel
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.impression_pixel &&
                                validation.errors.impression_pixel ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    {integration_type?.value === PRODUCT_TYPE_IDS.CLICKS &&
                        validation.values.lead_integration_phase?.value === LEAD_INTEGRATION_PHASE.PRE_FILL && (
                            <Col md={6} xl={6}>
                                <div className="mb-3">
                                    <LabelWithTooltip
                                        name={TOOLTIP_CONSTANTS.BASE_URL.NAME}
                                        tooltip_message={TOOLTIP_CONSTANTS.BASE_URL.TOOLTIP_MESSAGE}
                                        target={TOOLTIP_CONSTANTS.BASE_URL.ID}
                                        htmlFor="base_url"
                                    />
                                    <Input
                                        className="form-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        type="text"
                                        name="base_url"
                                        value={validation.values.base_url}
                                    />
                                </div>
                            </Col>
                        )}
                </>
            )}
            {(isInsuranceioBrand && integration_type?.value === PRODUCT_TYPE_IDS.CLICKS) && validation.values.lead_integration_phase?.value === LEAD_INTEGRATION_PHASE.PING && (
                <>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.PREMIUM.NAME} tooltip_message={TOOLTIP_CONSTANTS.PREMIUM.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.PREMIUM.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="premium"
                                value={validation.values.premium}
                                invalid={
                                    validation.touched.premium &&
                                        validation.errors.premium
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.premium &&
                                validation.errors.premium ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={6} xl={6}>
                        <div className="mb-3">
                            <LabelWithTooltip name={TOOLTIP_CONSTANTS.TERM.NAME} tooltip_message={TOOLTIP_CONSTANTS.TERM.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.TERM.ID} htmlFor="response-type" />
                            <Input
                                classNamePrefix="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                name="term"
                                value={validation.values.term}
                                invalid={
                                    validation.touched.term &&
                                        validation.errors.term
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.term &&
                                validation.errors.term ? (
                                <span className="text-danger">
                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                </>
            )}
            {/* Static Bids Checkbox - visible for all integration types when feature flag is enabled */}
            {isStaticBidsFeatureEnabled && (
                <Col md={12} xl={12}>
                    <div className="d-flex form-check form-switch form-switch-md mb-3">
                        <div>
                            <input
                                name="static_bids"
                                id={STATIC_BIDS_TOOLTIP.ID}
                                type="checkbox"
                                className="form-check-input"
                                value={validation.values?.static_bids}
                                checked={validation.values?.static_bids}
                                onChange={validation.handleChange}
                            />
                        </div>
                        <div>
                            <label className='font-weight-semibold mb-0'>{STATIC_BIDS_TOOLTIP.NAME}</label>
                            <p>
                                {STATIC_BIDS_TOOLTIP.TOOLTIP_MESSAGE}
                            </p>
                        </div>
                    </div>
                </Col>
            )}
            {/* FOLLOW_REDIRECT Checkbox - only visible if phase is pre-fill */}
            {isInsuranceioBrand && integration_type?.value === PRODUCT_TYPE_IDS.CLICKS && validation.values.lead_integration_phase?.value === LEAD_INTEGRATION_PHASE.PRE_FILL && (
                <Col md={12} xl={12}>
                    <div className="d-flex form-check form-switch form-switch-md mb-3">
                        <div>
                            <input
                                name="follow_redirect"
                                id={TOOLTIP_CONSTANTS.FOLLOW_REDIRECT.ID}
                                type="checkbox"
                                className="form-check-input"
                                value={validation.values?.follow_redirect}
                                checked={validation.values?.follow_redirect}
                                onChange={validation.handleChange}
                            />
                        </div>
                        <div>
                            <label className='font-weight-semibold mb-0'>{TOOLTIP_CONSTANTS.FOLLOW_REDIRECT.NAME}</label>
                            <p>
                                {TOOLTIP_CONSTANTS.FOLLOW_REDIRECT.TOOLTIP_MESSAGE}
                            </p>
                        </div>
                    </div>
                </Col>
            )}
        </Row>
    )
}

export default PingIntegration;
